import React from 'react';
import classnames from 'classnames';
import { Button as ButtonOwned } from '@lt/components';
import styles from './buttonWithLoader.module.css';
import { Loader } from './Loader';

type WidthType = React.CSSProperties['width'];

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  functional?: boolean;
  isLoading?: boolean;
  width?: WidthType;
  className?: string;
  size?: string;
}

export const ButtonWithLoader: React.FC<Props> = ({
  children,
  isLoading = false,
  width,
  className,
  size,
  ...rest
}) => (
  <div
    className={classnames(styles.container, className, {
      [styles.containerWidth]: width,
    })}
    style={{ width }}
  >
    <Loader isLoading={isLoading} />

    <ButtonOwned
      className={classnames(styles.button, className, {
        [styles.buttonWidth]: width,
      })}
      style={{ width }}
      _width={width}
      size={size}
      {...rest}
    >
      {!isLoading && children}
    </ButtonOwned>
  </div>
);
